import { frontendURL } from 'dashboard/helper/URLHelper';
import CommissionsView from './CommissionsView.vue';

const COMMISSIONS_PERMISSIONS = ['administrator', 'agent'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/commissions'),
    name: 'commissions_view',
    meta: {
      permissions: COMMISSIONS_PERMISSIONS,
    },
    component: CommissionsView,
  },
];
